export const iconFontAwesomePhotosImagesImagePortrait = (
	<i className="fa-solid fa-image-portrait"></i>
);
